// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"24":"bac4459a","100":"3cbab6ca","128":"78b7ade9","344":"9cbd2d43","352":"907dd539","448":"3c0f9210","512":"76196da0"}[chunkId] + ".chunk.js";
};